import { ControlPropertyType } from '../../../enums';
import { OptionProperty } from '../../select/enums';

export const CardsProperty = {
  ...ControlPropertyType,
  Options: 'options',
  Multiple: 'multiple',
};

export const CardProperty = {
  ...OptionProperty,
  Name: 'name',
  Disabled: 'disabled',
  Checked: 'checked',
  IsActive: 'isActive',
  ControlType: 'controlType',
};

export default {
  CardsProperty,
  CardProperty,
};
